/**
 * 🚨 This file is generated by scripts/zendesk.ts. Don't modify it manually!
 */

export const overseasTravelCustomFieldAU = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: 360004390118 },
  Assignee: { prod: 360013722033, nonProd: 376888316957 },
  "Customers first name": { prod: 360006712378, nonProd: 360010706397 },
  "Surname  (as it appears on ID)": {
    prod: 360026751773,
    nonProd: 360010709557,
  },
  DOB: { prod: 360022862154, nonProd: 360010707057 },
  "Mobile Number": { prod: 360006010038, nonProd: 360010707337 },
  "Departure Date - Overseas Travel": {
    prod: 360015922378,
    nonProd: 360025423617,
  },
  "Return Date - Overseas Travel": {
    prod: 360015922398,
    nonProd: 360025423637,
  },
  "Destination - Overseas Travel": {
    prod: 360015993937,
    nonProd: 360025423657,
  },
  "Additional Card Holders - Overseas Travel": {
    prod: 360015922558,
    nonProd: 360025423677,
  },
  "Additional Holder 1 - Overseas Travel": {
    prod: 360015993957,
    nonProd: 360025259238,
  },
  "Additional Holder 2 - Overseas Travel": {
    prod: 360015922578,
    nonProd: 1900000846313,
  },
  "Additional Holder 3 - Overseas Travel": {
    prod: 360015994117,
    nonProd: 360025423697,
  },
  "Additional Holder 4 - Overseas Travel": {
    prod: 360015994137,
    nonProd: 1900000846473,
  },
  "Additional Holder 5 - Overseas Travel": {
    prod: 360015922598,
    nonProd: 1900000846633,
  },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
  Subject: { prod: 360013721913, nonProd: "NA" },
  Description: { prod: 360013721933, nonProd: "NA" },
};
